<template>
  <v-card class="rounded-card card-shadow">
    <v-card-text>
      <v-row dense>
        <v-col cols="12" :sm="isEmEdicao ? '10' : '7'">
          <p class="mb-1">
            <v-chip label class="mb-2" v-if="finalizacao.codigoInterno">
              <px-span-tooltip
                bottom
                :text="finalizacao.codigoInterno"
                tooltip="Número da OC"/>
            </v-chip>
            <span class="headline text--primary">
              {{ finalizacao.comprador.pessoa.nome }}
              <px-popover-comprador :comprador="finalizacao.comprador"/>
            </span>
            <px-situacao-compra-tag :situacao="finalizacao.situacao"
                                    comprador-color="blue lighten-1"
                                    fornecedor-color="amber darken-1"/>
            <v-chip color="secondary" label v-if="isCatalogo">
              Catálogo
            </v-chip>
          </p>
        </v-col>
        <v-col cols="12" :sm="isEmEdicao ? '2' : '5'" class="text-right">
          <template v-if="isPendenteFornecedor">
            <px-finalizacao-recusar-dialog :compra-id="compraId"
                                           :compra="finalizacao"
                                           @movimentar="onMovimentar"/>
            <px-finalizacao-aprovar-dialog :compra-id="compraId"
                                           :compra="finalizacao"
                                           v-if="!isCotacaoConjunta && isAprovacaoEnabled"
                                           @movimentar="onMovimentar"/>
            <px-finalizacao-confirm-approve-dialog
              :request-id="compraId"
              v-if="!isCotacaoConjunta && !isAprovacaoEnabled"
              :name="finalizacao.comprador.pessoa.nome"
              @update="onMovimentar"
            />
            <px-venda-conjunta-aprovar-pedido :venda="finalizacao"
                                              :icon="false"
                                              color="primary"
                                              v-if="isCotacaoConjunta"
                                              @update="onMovimentar"/>
          </template>
          <px-detalhes-finalizacao-print-pdf :venda="finalizacao"/>
        </v-col>
      </v-row>
      <p class="mt-2">
        <v-icon>mdi-shopping-outline</v-icon>
        Número do pedido Proxpect - {{ finalizacao.id }}
      </p>
      <p class="mt-2">
        <v-icon>mdi-domain</v-icon>
        {{ finalizacao.comprador.pessoa.cnpj | cnpj }}
      </p>
      <p>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon>mdi-map-marker</v-icon>
              {{ finalizacao.compradorEntrega.endereco | endereco }}
            </span>
          </template>
          <span>Endereço de entrega</span>
        </v-tooltip>
      </p>
      <div class="text--primary">
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Forma de pagamento</span>
            <div>
              <px-forma-pagamento :forma-pagamento="finalizacao.formaPagamento"
                                  :prazo-pagamento="finalizacao.prazoPagamento"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Tipo de frete</span>
            <div>
              {{ finalizacao.frete.tipoFrete }}
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="finalizacao.usuario">
            <span class="caption font-weight-bold">Comprador responsável</span>
            <div>
              {{ finalizacao.usuario.nome }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Finalidade da Compra</span>
            <div v-if="finalizacao.finalidadeCompra">
              <px-finalidade-compra-value :finalidade-compra="finalizacao.finalidadeCompra"/>
            </div>
            <div v-else>
              Não Informado
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Mensagem do comprador</span>
            <div>
              <px-show-large-text :large-text="finalizacao.mensagem"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Anexos</span>
            <div v-if="finalizacao.arquivos.length">
              <px-anexo-chip :files="finalizacao.arquivos"
                             :download-base-path="downloadFilePath"/>
            </div>
            <div v-else>
              Nenhum anexo informado
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Mensagem para o comprador</span>
            <div>
              <px-show-large-text :large-text="finalizacao.mensagemFornecedor"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Data de Faturamento</span>
            <div>
              {{ finalizacao.dataFaturamento | date | naoInformado }}
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3" v-if="hasTransportadora">
            <span class="caption font-weight-bold">Transportadora</span>
            <div>
              {{ finalizacao.transportadora.pessoa.nome }}
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="isRecusadoCancelado">
            <span class="caption font-weight-bold">Motivo da recusa/cancelamento</span>
            <div>
              <px-show-large-text :large-text="finalizacao.motivoRecusa"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="finalizacao.tipoNotaEntrada">
            <span class="caption font-weight-bold">Tipo de nota de entrada</span>
            <div>
              <px-span-tooltip top
                               :text="notaEntrada"
                               :tooltip="finalizacao.tipoNotaEntrada.descricao"/>
            </div></v-col>
          <v-col cols="12" sm="3" v-if="finalizacao.cfop">
            <span class="caption font-weight-bold">CFOP da compra</span>
            <div>
              <px-span-tooltip top
                               :text="cfop"
                               :tooltip="tooltipCfop"/>
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3" v-if="finalizacao.modoPagamento">
            <span class="caption font-weight-bold">Modo de pagamento</span>
            <div>
              {{ finalizacao.modoPagamento.descricao }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <px-responsaveis :responsaveis="finalizacao.fornecedoresReponsaveis"
                             custom-path="compras"
                             :id="finalizacao.id"
                             @update="onMovimentar"/>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { OrigemCompra, SituacaoCompra, TipoFrete } from 'px-business-components';
import Vue from 'vue';
import VendaConjuntaAprovarPedido from '@/modules/venda-conjunta/VendaConjuntaAprovarPedido.vue';
import DetalhesFinalizacaoPrintPdf from '@/modules/vendas/finalizacao/DetalhesFinalizacaoPrintPdf.vue';
import FinalizacaoConfirmApproveDialog from './FinalizacaoConfirmApproveDialog.vue';
import FinalizacaoAprovarDialog from './FinalizacaoAprovarDialog.vue';
import FinalizacaoRecusarDialog from './FinalizacaoRecusarDialog.vue';

export default {
  props: {
    finalizacao: Object,
    compraId: String,
  },
  computed: {
    notaEntrada() {
      return Vue.filter('truncate')(this.finalizacao.tipoNotaEntrada.descricao, 20);
    },
    cfop() {
      return `${this.finalizacao.cfop.codigo} - ${Vue.filter('truncate')(this.finalizacao.cfop.descricao, 15)}`;
    },
    isAprovacaoEnabled() {
      return !this.finalizacao.entidadeComprador.pularAprovacaoFornecedor;
    },
    hasTransportadora() {
      return this.finalizacao.transportadora;
    },
    isPendenteFornecedor() {
      return this.finalizacao.situacao === SituacaoCompra.keys.PENDENTE_FORNECEDOR.key;
    },
    isRecusadoCancelado() {
      return this.finalizacao.situacao === SituacaoCompra.keys.RECUSADA.key
        || this.finalizacao.situacao === SituacaoCompra.keys.CANCELADA.key;
    },
    isCotacaoConjunta() {
      return this.finalizacao.origemCompra === OrigemCompra.keys.COTACAO_CONJUNTA.key
        || this.finalizacao.origemCompra === OrigemCompra.keys.CATALOGO_COMPRA_CONJUNTA.key;
    },
    isCatalogo() {
      return this.finalizacao.origemCompra === OrigemCompra.keys.CATALOGO_COMPRA_CONJUNTA.key;
    },
    isEmEdicao() {
      return this.finalizacao.situacao === SituacaoCompra.keys.AGUARDANDO_APROVACAO_INTERNA.key;
    },
    downloadFilePath() {
      return `fornecedor/compras/${this.compraId}/file`;
    },
    labelFrete() {
      return this.isCif ? 'Entrega' : 'Embarque';
    },
    isCif() {
      return this.finalizacao.frete.tipoFrete === TipoFrete.keys.CIF.key;
    },
    tooltipCfop() {
      return `${this.finalizacao.cfop.codigo} - ${this.finalizacao.cfop.descricao}`;
    },
  },
  methods: {
    onMovimentar() {
      this.$emit('movimentar');
    },
  },
  components: {
    pxFinalizacaoAprovarDialog: FinalizacaoAprovarDialog,
    pxFinalizacaoRecusarDialog: FinalizacaoRecusarDialog,
    pxVendaConjuntaAprovarPedido: VendaConjuntaAprovarPedido,
    pxFinalizacaoConfirmApproveDialog: FinalizacaoConfirmApproveDialog,
    pxDetalhesFinalizacaoPrintPdf: DetalhesFinalizacaoPrintPdf,
  },
};
</script>
